import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import {
    fetchIOChannel,
    fetchIOChannelCreatives,
    fetchIOChannelTargetingTactics,
    fetchIOChannelPlacements,
    fetchIOChannelActivities
} from 'services/siteDirect/duck';
import { shouldShowTotalActivities } from 'helpers/data';

import { withRouter } from 'react-router-dom';
import { SiteDirectChannelDashboardComponent } from 'containers/dashboards/DashboardBaseComponent';
import GenericSiteDirectExpandModule from 'components/organisms/siteDirect/GenericSiteDirectExpandModule';
import AudioExpandModule from 'components/organisms/siteDirect/AudioExpandModule';
import VideoExpandModule from 'components/organisms/siteDirect/VideoExpandModule';

class GenericSiteDirectExpandContainer extends SiteDirectChannelDashboardComponent {
    constructor(props) {
        super(props, props.ioChannel);
    }

    makeRequestsForData() {
        const entityId = this.getCurrentEntityId();
        const ioChannel = this.getCurrentIOChannel();
        const payload = this.createPayload(entityId, ioChannel);

        this.props.fetchIOChannel(payload);
        this.props.fetchIOChannelCreatives(payload);
        this.props.fetchIOChannelPlacements(payload);
        this.props.fetchIOChannelTargetingTactics(payload);
        this.props.fetchIOChannelActivities(payload);
    }

    render() {
        const { hide, ioChannel } = this.props;

        let TheModule;
        switch (ioChannel) {
        case 'audio':
            TheModule = AudioExpandModule;
            break;
        case 'video':
            TheModule = VideoExpandModule;
            break;
        case 'display':
        case 'mobile':
        case 'native':
        default:
            TheModule = GenericSiteDirectExpandModule;
        }

        return (
            !hide ?
                <TheModule
                    theme={this.props.theme}
                    entityMeta={this.props.entityMeta}
                    xAxisLabel={this.props.xAxisLabel}
                    backfillBuckets={this.props.backfillBuckets}
                    channel={this.props.channel}
                    placements={this.props.placements}
                    activities={this.props.activities}
                    ioChannel={this.props.ioChannel}
                    entityObjective={this.props.entityObjective}
                    showTotalActivities={this.props.showTotalActivities} /> : null
        );
    }
}

const mapStateToProps = (state, props) => ({
    theme: state.theme,
    entityMeta: state.entities.meta,
    selectedTimeRange: state.config.selectedTimeRange,
    xAxisLabel: get(state, 'config.timeBuckets.config.xAxisLabel', 'Date'),
    channel: state.siteDirect.channels[props.ioChannel],
    placements: state.siteDirect.channels[props.ioChannel].placements,
    activities: state.siteDirect.channels[props.ioChannel].activities,
    backfillBuckets: get(state, 'config.timeBuckets.config.buckets', []),
    entityObjective: get(state, 'entities.meta.meta.programmaticObjective.global', 'ecpa'),
    showTotalActivities: shouldShowTotalActivities(state)
});

export default withRouter(
    connect(mapStateToProps, {
        fetchIOChannel,
        fetchIOChannelCreatives,
        fetchIOChannelTargetingTactics,
        fetchIOChannelPlacements,
        fetchIOChannelActivities

    })(GenericSiteDirectExpandContainer));



// WEBPACK FOOTER //
// ./src/containers/dashboards/siteDirect/GenericSiteDirectExpandContainer.js